import React from 'react';
import styles from './DashboardSidebar.module.scss';
import clsx from 'clsx';
import { DashboardSidebarProps } from './constants';
import { useLocation } from 'react-router-dom';
import { DownOutlined, BellOutlined } from '@ant-design/icons';
import { Badge, Popover } from 'antd';
import { LogoutPopupPropsEnums } from 'enums/LogoutPopupEnums';
import NotificationPopup from './NotificationPopup';
import COAvatar from '../COAvatar';
import UserProfile from 'assets/images/default_user.png';
import HelpIcon from 'assets/icons/help.svg';
import CompanySelected from 'assets/icons/company-selected.svg';
import Company from 'assets/icons/companyIcon.svg';
import TargetIcon from 'assets/icons/target2.svg';
import LightTargetIcon from 'assets/icons/target.svg';
import DashboardIcon from 'assets/icons/dashboard_tog.svg';
import DashboardActive from 'assets/icons/dashboard_def.svg';
import Product from 'assets/icons/product_tog.svg';
import ProductActive from 'assets/icons/product_def.svg';
import FarmActiveIcon from 'assets/icons/farmActive.svg';
import FarmIcon from 'assets/icons/farm.svg';
import LogoutPopup from '../LogoutPopup';

interface SidebarElementsProps {
  isDashboardDropdown: boolean;
  setIsDashboardDropdown: (value: boolean) => void;
  isProductDropdown: boolean;
  setIsProductDropdown: (value: boolean) => void;
  handleCompanyDashboardNavigation: () => void;
  handleCompanySetupNavigation: () => void;
  handleDashboardNavigation: () => void;
  handleProductNavigation: () => void;
  handleValueChainNavigation: () => void;
  handleTargetsNavigation: () => void;
  handleFarmNavigation: () => void;
  handleUtilityDashboardNavigation: () => void;
  handleWasteDashboardNavigation: () => void;
  toggleHelpVideoModal: () => void;
  fetchUnreadCount: () => void;
  notificationCount: number;
  Logout: () => void;
}

const SidebarElements: React.FC<SidebarElementsProps> = ({
  isDashboardDropdown,
  setIsDashboardDropdown,
  isProductDropdown,
  setIsProductDropdown,
  handleCompanyDashboardNavigation,
  handleCompanySetupNavigation,
  handleDashboardNavigation,
  handleProductNavigation,
  handleValueChainNavigation,
  handleTargetsNavigation,
  handleFarmNavigation,
  handleUtilityDashboardNavigation,
  handleWasteDashboardNavigation,
  toggleHelpVideoModal,
  fetchUnreadCount,
  notificationCount,
  Logout,
}) => {
  const location = useLocation();
  const isActiveScreen = (key: string) => {
    let currentPage = location.pathname.split('/')[1];
    return currentPage === key;
  };

  const isDashboardRouteActive =
    isActiveScreen(DashboardSidebarProps.COMPANY_DASHBOARD) ||
    isActiveScreen(DashboardSidebarProps.UTILITY_DASHBOARD) ||
    isActiveScreen(DashboardSidebarProps.WASTE_DASHBOARD);

  const handleDashboardDropdown = () => {
    setIsDashboardDropdown(!isDashboardDropdown);
    if (!isDashboardDropdown) setIsProductDropdown(false);
  };

  const handleProductDropdown = () => {
    setIsProductDropdown(!isProductDropdown);
    if (!isProductDropdown) setIsDashboardDropdown(false);
  };

  return (
    <div>
      <div
        className={clsx({
          [styles.itemContainer]: true,
          [styles.bgGrey]: isDashboardDropdown,
        })}>
        <div
          className={clsx({
            [styles.activeRouteContainer]: true,
            [styles.activeRoute]: isDashboardRouteActive,
          })}>
          <img
            src={isDashboardRouteActive ? DashboardIcon : DashboardActive}
            alt={DashboardSidebarProps.DASHBOARD_TEXT}
            className={styles.topIcons}
          />
          <p onClick={handleDashboardDropdown}>
            {DashboardSidebarProps.DASHBOARD_TEXT}{' '}
            <DownOutlined style={{ marginLeft: 15, fontSize: 8 }} />
          </p>
        </div>
      </div>
      {isDashboardDropdown && (
        <div className={styles.dropdownBox}>
          <p
            className={clsx({
              [styles.activeDashboard]: isActiveScreen(
                DashboardSidebarProps.COMPANY_DASHBOARD
              ),
              [styles.dropdownText]: true,
            })}
            onClick={handleCompanyDashboardNavigation}>
            {DashboardSidebarProps.EMISSION_DASHBOARD_TEXT}
          </p>
          <p
            className={clsx({
              [styles.activeDashboard]: isActiveScreen(
                DashboardSidebarProps.UTILITY_DASHBOARD
              ),
            })}
            onClick={handleUtilityDashboardNavigation}>
            {DashboardSidebarProps.UTILITY_DASHBOARD_TEXT}
          </p>
          <p
            className={clsx({
              [styles.activeDashboard]: isActiveScreen(
                DashboardSidebarProps.WASTE_DASHBOARD
              ),
            })}
            onClick={handleWasteDashboardNavigation}>
            {DashboardSidebarProps.WASTE_DASHBOARD_TEXT}
          </p>
        </div>
      )}
      <div
        className={clsx({
          [styles.itemContainer]: true,
          [styles.activeIcon]: isActiveScreen(
            DashboardSidebarProps.COMPANY_SETUP
          ),
        })}
        onClick={handleCompanySetupNavigation}>
        <div
          className={clsx({
            [styles.activeRouteContainer]: true,
            [styles.activeRoute]: isActiveScreen(
              DashboardSidebarProps.COMPANY_SETUP
            ),
          })}>
          <img
            src={
              isActiveScreen(DashboardSidebarProps.COMPANY_SETUP)
                ? CompanySelected
                : Company
            }
            alt={DashboardSidebarProps.COMPANY_SETUP}
            className={styles.topIcons}
          />
          <p>{DashboardSidebarProps.COMPANY}</p>
        </div>
      </div>
      <div
        className={clsx({
          [styles.itemContainer]: true,
          [styles.bgGrey]: isProductDropdown,
        })}>
        <div
          className={clsx({
            [styles.activeRouteContainer]: true,
            [styles.activeRoute]:
              isActiveScreen(DashboardSidebarProps.PRODUCTS_INDEX) ||
              isActiveScreen(DashboardSidebarProps.DASHBOARD_INDEX) ||
              isActiveScreen(DashboardSidebarProps.VALUE_CHAIN_INDEX) ||
              isActiveScreen(DashboardSidebarProps.CREATE_PRODUCT),
          })}>
          <img
            src={
              isActiveScreen(DashboardSidebarProps.PRODUCTS_INDEX) ||
              isActiveScreen(DashboardSidebarProps.DASHBOARD_INDEX) ||
              isActiveScreen(DashboardSidebarProps.VALUE_CHAIN_INDEX) ||
              isActiveScreen(DashboardSidebarProps.CREATE_PRODUCT)
                ? ProductActive
                : Product
            }
            alt={DashboardSidebarProps.PRODUCTS_ICON_ALT}
            className={styles.topIcons}
          />
          <p onClick={handleProductDropdown}>
            {DashboardSidebarProps.PRODUCTS_ICON_ALT}{' '}
            <DownOutlined style={{ marginLeft: 15, fontSize: 8 }} />
          </p>
        </div>
      </div>
      {isProductDropdown && (
        <div className={styles.dropdownBox}>
          <p
            className={clsx({
              [styles.activeDashboard]: isActiveScreen(
                DashboardSidebarProps.DASHBOARD_INDEX
              ),
              [styles.dropdownText]: true,
            })}
            onClick={handleDashboardNavigation}>
            {DashboardSidebarProps.DASHBOARD}
          </p>
          <p
            className={clsx({
              [styles.activeDashboard]: isActiveScreen(
                DashboardSidebarProps.PRODUCTS_INDEX
              ),
            })}
            onClick={handleProductNavigation}>
            {DashboardSidebarProps.PRODUCT_LISTING}
          </p>
          <p
            className={clsx({
              [styles.activeDashboard]: isActiveScreen(
                DashboardSidebarProps.VALUE_CHAIN_INDEX
              ),
            })}
            onClick={handleValueChainNavigation}>
            {DashboardSidebarProps.VALUE_CHAIN}
          </p>
        </div>
      )}

      <div
        className={clsx({
          [styles.itemContainer]: true,
          [styles.activeIcon]: isActiveScreen(DashboardSidebarProps.TARGETS),
        })}
        onClick={handleTargetsNavigation}>
        <div
          className={clsx({
            [styles.activeRouteContainer]: true,
            [styles.activeRoute]: isActiveScreen(
              DashboardSidebarProps.TargetPage
            ),
          })}>
          <img
            src={
              isActiveScreen(DashboardSidebarProps.TargetPage)
                ? TargetIcon
                : LightTargetIcon
            }
            alt={DashboardSidebarProps.TARGETS}
            className={styles.topIcons}
          />
          <p>{DashboardSidebarProps.TARGETS}</p>
        </div>
      </div>
      <div
        className={clsx({
          [styles.itemContainer]: true,
          [styles.activeIcon]: isActiveScreen(DashboardSidebarProps.FARM),
        })}
        onClick={handleFarmNavigation}>
        <div
          className={clsx({
            [styles.activeRouteContainer]: true,
            [styles.activeRoute]: isActiveScreen(DashboardSidebarProps.FARM),
          })}>
          <img
            src={
              isActiveScreen(DashboardSidebarProps.FARM)
                ? FarmActiveIcon
                : FarmIcon
            }
            alt={DashboardSidebarProps.FARM}
            className={styles.topIcons}
          />
          <p>{DashboardSidebarProps.FARM}</p>
        </div>
      </div>
      <div className={styles.iconContainer}></div>
      <div className={styles.extraSpace}></div>
      <div
        style={{ marginBottom: -5 }}
        className={clsx({
          [styles.itemContainer]: true,
        })}
        onClick={toggleHelpVideoModal}>
        <div
          className={clsx({
            [styles.activeRouteContainer]: true,
          })}>
          <img
            src={HelpIcon}
            alt={DashboardSidebarProps.HELP_MENU_LABEL}
            className={clsx(
              {
                [styles.topIcons]: true,
                [styles.accounts]: true,
              },
              styles.notificationIcon
            )}
          />
          <p>{DashboardSidebarProps.HELP_MENU_LABEL}</p>
        </div>
      </div>

      <Popover
        overlayClassName={`${styles.notificationOverlay} notification-overlay`}
        title={LogoutPopupPropsEnums.EMPTY_STRING}
        trigger={LogoutPopupPropsEnums.CLICK_TRIGGER}
        placement={LogoutPopupPropsEnums.RIGHT}
        content={<NotificationPopup fetchUnreadCount={fetchUnreadCount} />}
        arrowPointAtCenter={false}
        destroyTooltipOnHide={true}>
        <div className={clsx(styles.itemContainer)}>
          <div className={clsx(styles.defaultView)}>
            <Badge count={notificationCount}>
              <BellOutlined
                style={{ marginTop: -2, marginLeft: -5 }}
                className={styles.bellIcon}
              />
            </Badge>
          </div>

          <div className={clsx(styles.hoverView)}>
            <BellOutlined
              style={{ marginTop: -2 }}
              className={styles.bellIcon}
            />
            <p style={{ marginTop: -16 }}>
              {DashboardSidebarProps.NOTIFICATIONS}
              <Badge
                style={{ marginTop: -14, marginRight: -15 }}
                count={notificationCount}
              />
            </p>
          </div>
        </div>
      </Popover>
      <LogoutPopup logout={Logout}>
        <div
          className={clsx({
            [styles.itemContainer]: true,
            [styles.avatarContainer]: true,
          })}>
          <div
            className={clsx({
              [styles.activeRouteContainer]: true,
            })}>
            <div className={styles.avatarContainer}>
              <COAvatar icon={UserProfile} size={20} />
            </div>

            <p style={{ marginTop: -12 }}>{DashboardSidebarProps.PROFILE}</p>
          </div>
        </div>
      </LogoutPopup>
    </div>
  );
};

export default SidebarElements;
